/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TwoFactorCellverification$Params {
  cellNo?: string | null;
}

export function twoFactorCellverification(http: HttpClient, rootUrl: string, params?: TwoFactorCellverification$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, twoFactorCellverification.PATH, 'get');
  if (params) {
    rb.query('cellNo', params.cellNo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

twoFactorCellverification.PATH = '/2factor/cellverification';
